import { prop } from "vue-class-component";

import { IModifyCategorieParameters } from "@/models";

export default class ModifyCategorieModalProps {
    modifyCategorieParameters: IModifyCategorieParameters = prop({
        required: true,
    });
}
